import { CaseArtifactTypes } from '../../enums';

const defaultSet = new Set<string>([
  CaseArtifactTypes.CLINICAL, // from hl7
  CaseArtifactTypes.CLAIM, // from historical.  if we have it, should show it.
  CaseArtifactTypes.PROCESSED, // from code assembly
  CaseArtifactTypes.CODED // codes sent to the payer.
]);

const submissionSet = new Set<string>([
  CaseArtifactTypes.CLINICAL, // from hl7
  CaseArtifactTypes.CLAIM, // from historical.  if we have it, should show it.
  CaseArtifactTypes.PROCESSED,
  CaseArtifactTypes.SUBMITTED, //
  CaseArtifactTypes.CODED // codes sent to the payer.
]);

const omitProcessed = new Set<string>([
  CaseArtifactTypes.CLINICAL, // from hl7
  CaseArtifactTypes.CLAIM, // from historical.  if we have it, should show it.
  CaseArtifactTypes.CODED // codes sent to the payer.
]);

const inProgressDefaultSet = new Set<string>([
  CaseArtifactTypes.CLINICAL, // from hl7
  CaseArtifactTypes.CLAIM, // from historical.  if we have it, should show it.
  CaseArtifactTypes.ASSEMBLED, // from code assembly
  CaseArtifactTypes.CODED // codes sent to the payer.
]);

const completeSet = new Set<string>([
  CaseArtifactTypes.MAPPED,
  CaseArtifactTypes.CLINICAL,
  CaseArtifactTypes.PREDICTION,
  CaseArtifactTypes.PROCESSED,
  CaseArtifactTypes.SUBMITTED,
  CaseArtifactTypes.ASSEMBLED,
  CaseArtifactTypes.CLAIM,
  CaseArtifactTypes.REMITTANCE,
  CaseArtifactTypes.REFERRAL,
  CaseArtifactTypes.CODED
]);

export {
  defaultSet,
  completeSet,
  inProgressDefaultSet,
  omitProcessed,
  submissionSet
};
